import { withWixStyle } from './useWixStyle';
import { withNativeStyle } from './useNativeStyle';
import { withLiveSiteStyle } from './useLiveSiteStyle';
export const themeStrategy = ({ useWixStyles, useNativeStyles, ...rest } = {}, experiments = {}, isBmPlatform = false) => {
    const isWithWixStylesEnabled = experiments?.withWixStyles?.enabled;
    const shouldUseWixStyles = useWixStyles ?? (isBmPlatform && !!isWithWixStylesEnabled);
    return useNativeStyles
        ? withNativeStyle(rest)
        : shouldUseWixStyles
            ? withWixStyle(rest)
            : withLiveSiteStyle(rest);
};
//# sourceMappingURL=themeStrategy.js.map